import React, {Component} from 'react';
import { connect } from "react-redux"; 
import { loadGamesApi } from "../../actions/sportsEventsActions";
import Game from '../game/Game';
import { Skeleton } from '@mui/material';

class SportsEvents extends Component {
    constructor(props) {
        super(props)
        // load the data from the initFn set in mapDispatchToProps
        this.props.initFn();
        setInterval(this.props.initFn, 60000);
      }

    render() {
        if (!this.props.sportsEventsReducer.loaded){
            
            const sk = Array.apply(null, Array(5)).map(n=> <div key={n} className="daily-event__item">
                <Skeleton variant="text" height={40} width="100%" />
            </div>);

            // Data not yet loaded
            return (
                <div className="daily-event">
                <div className="daily-event__date">
                    <div className="daily-event__day-name">
                        ...
                    </div>
                    <div className="daily-event__day">
                        Matches D1
                    </div>
                </div>
                {sk}
            </div>
            );
        }
        console.log(this.props.sportsEventsReducer.games);
        if (this.props.sportsEventsReducer.games === undefined || this.props.sportsEventsReducer.games === null || this.props.sportsEventsReducer.games.games === null ||this.props.sportsEventsReducer.games.games.length === 0)
        {
            return (
                <div className="daily-event">
                <div className="daily-event__date">
                    <div className="daily-event__day-name">
                        ...
                    </div>
                    <div className="daily-event__day">
                        Matches D1
                    </div>
                </div>
                <div className="daily-event__item daily-event__item--empty">
                        Aucun match prévu
                </div>
            </div>
            );
        }

        //let dailyEvents = this.props.sportsEventsReducer.data.dailyEvents.map(function(item, index){        
        //    return <DailyEvent key={index} item={item}/>;});

        let games = this.props.sportsEventsReducer.games.games.map(function(item, index){
            return <Game key={index} item={item} />});
        
        return (
            <div className="daily-event">
            <div className="daily-event__date">
                <div className="daily-event__day-name">
                Matches D1
                </div>
            </div>
                {games}
                </div>
        )
    }

}


const mapDispatchToProps = dispatch => {
    return {
        // Put in the props the dispatch to load the data
        initFn: () => dispatch(loadGamesApi()),
    }
}

const mapStateToProps = state => ({
    ///...state,
    sportsEventsReducer: state.sportsEventsReducer,

});

export default connect(mapStateToProps, mapDispatchToProps)(SportsEvents);